/** Delay before the toolbar appears after mouse enters the area, in seconds */
export const DEFAULT_TOOLBAR_MOUSE_ENTER_DELAY = 1; // seconds
